import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Button,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../../../Sass/Common.scss";

import { ReactComponent as RepeatSmart } from "Assets/Logo/RepeatSmart.svg";
import { ReactComponent as CloseIcon } from "../../../Assets/Icons/CloseIcon.svg";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import { START_PAYMENT_LINK } from "../../../Actions/HomeAction";
import { START_GET_LOGIN_USER } from "../../../Actions/UserAction";
import PrimaryIcon from "../PrimaryIcon";
const useStyle = makeStyles((theme) => ({
  dialogMain: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      position: "absolute",
      top: "0 !important",
    },
    "& .MuiDialogTitle-root": {
      borderBottom: "none",
      "&>p": {
        "&>svg": {
          position: "relative",
          top: "18px",
          right: "28px",
        },
      },
    },
  },
  rsNoteGrid: {
    "& .MuiTableBody-root": {
      "&>tr": {
        "&>td": {
          padding: "12px 17px !important",
        },
      },
    },
    "&>div": {
      textAlign: "center",
      display: "grid",
      justifyContent: "center",
    },
  },
  rsBillingSubtitle: {
    fontSize: "16px !important",
    fontWeight: "300 !important",
    textAlign: "center",
    color: "black  !important",
    marginTop: "20px",
    paddingRight: "5px",
  },

  rsSubtitle: {
    display: "grid",
    textAlign: "center",
    width: "100%",
    justifyContent: "center",
    "&>button": {
      marginBottom: "20px",
    },
  },

  rsWarning: {
    marginTop: "50px",
    width: "290px",
  },
  rsWarningSubscription: {
    width: "88%",
    marginTop: "50px",
    fontSize: "20px !important",
    fontWeight: "500 !important",
  },
  CloseIcon: {
    position: "absolute !important",
    top: "20px",
    right: "20px",
  },
  rsMain: {
    display: "inline-grid",
    textAlign: "center",
    justifyContent: "center",
    justifyItems: "center",
  },
  rsFormHelperText: {
    width: "100%",
    justifyContent: "center",
    textAlign: "center",
  },
}));

const PaymentLinkDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    paymentLinkAction,
    paymentLink,
    copyUrl,
    message,
    email,
    paymentLinkAdd,
  } = props;
  const loginUserDetail = useSelector((state) => state.user);
  /**handle close dialog */
  const [selected, setSelected] = useState("");
  const [submit, setSubmit] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setSubmit(false);
  };
  const handleSubmit = (duration) => {
    if (copyUrl === "is_email") {
      const payload = {
        duration: duration,
        is_send_mail: true,
        message: message,
        email: email,
      };
      setSubmit(true);
      paymentLinkAction(payload);
    } else {
      const payload = {
        duration: duration,
        message: message,
        email: email,
        is_send_mail: true,
      };
      setSubmit(true);
      paymentLinkAction(payload);
    }
  };
  return (
    <>
      <Dialog
        open={open}
        maxWidth={"sm"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        className={classes.dialogMain}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <IconButton className={classes.CloseIcon} onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon icon={CloseIcon} />{" "}
        </IconButton>
        <Box className={classes.rsMain}>
          <Box className={classes.rsWarningSubscription}>
            Do you want to renew your Repeatsmart subscription?
          </Box>
        </Box>

        <Box className={classes.rsNoteGrid}>
          <DialogContent>
            <Box className={classes.rsSubtitle}>
              <Button
                variant="contained"
                disabled={paymentLinkAdd?.loading && selected == "6_month"}
                startIcon={
                  paymentLinkAdd?.loading &&
                  selected == "6_month" && (
                    <CircularProgress color="white" size="20px" />
                  )
                }
                onClick={() => {
                  handleSubmit("6_month");
                  setSelected("6_month");
                }}
              >
                Yes, 6 Months
              </Button>
              <Button
                variant="contained"
                disabled={paymentLinkAdd?.loading && selected == "12_month"}
                startIcon={
                  paymentLinkAdd?.loading &&
                  selected == "12_month" && (
                    <CircularProgress color="white" size="20px" />
                  )
                }
                onClick={() => {
                  handleSubmit("12_month");
                  setSelected("12_month");
                }}
              >
                Yes, 1 Year
              </Button>
              <Button
                // disabled={paymentLinkAdd?.loading}
                // startIcon={
                //   paymentLinkAdd?.loading && (
                //     <CircularProgress color="white" size="20px" />
                //   )
                // }
                variant="contained"
                onClick={() => {
                  handleClose();
                  setSelected("");
                }}
              >
                No, Thanks
              </Button>
            </Box>
            {submit && (
              <FormHelperText
                error={paymentLinkAdd?.error?.errors?.duration[0]}
                className={classes.rsFormHelperText}
              >
                {paymentLinkAdd?.error?.errors?.duration[0]}
              </FormHelperText>
            )}
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  paymentCreate: state.home.paymentCreate,
  paymentLink: state.home.paymentLink,
  paymentLinkAdd: state.home.paymentLinkAdd,
});
const mapDispatchToProps = (dispatch) => ({
  paymentLinkAction: (payload) =>
    dispatch({ type: START_PAYMENT_LINK, payload }),
  getLoginUserAction: () => dispatch({ type: START_GET_LOGIN_USER }),
});
export default connect(mapStateToProps, mapDispatchToProps)(PaymentLinkDialog);
